import React from 'react';

function SubmitButton({ children, onClick, width }) {
  const buttonStyle = {
    width: width || '100%',
  };

  return (
    <button
      className="bg-green font-semibold uppercase text-black text-lg px-6 py-3"
      style={buttonStyle}
      type="submit"
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export default SubmitButton;
